<template>
  <div class="reports-add-jobs">
    <el-button size="small" class="add" type="primary" @click="open" style="width: 100%">
      + Выбрать {{ tr[type || $route.params.type] }}
    </el-button>

    <el-dialog
      :title="isCreateJob ? `Создать ${tr[type || $route.params.type]}` : `Выбрать ${tr[type || $route.params.type]}`"
      :visible.sync="dialogObject"
      @close="clear"
    >
      <div v-if="isCreateJob" class="jobs-create-container">
        <JobsCreate
          :type_prop="type"
          v-if="(type || $route.params.type) !== 'MATERIALS'"
          :obj="obj && obj.id"
          @close="isCreateJob = false"
          @created="fetchJobs"
          isNested
        />
        <MaterialsCreate
          v-else
          :obj="obj && obj.id"
          @close="isCreateJob = false"
          @created="fetchJobs"
          isNested
        />
      </div>
      <div class="add-jobs" v-else-if="!form.job && !isCreateCustom">
        <el-input placeholder="Поиск ..." v-model="search" class="input-search">
          <el-button slot="append" icon="el-icon-search"></el-button>
        </el-input>
        <div class="jobs-ul">
          <div
            class="jobs-li" v-for="(job, index) in filteredList" :key="index" @click="form.job = job"
          >
            <span>{{ job.name }}</span>
          </div>
          <div class="jobs-li link" v-if="(type || $route.params.type) === 'JOB'">
            <span @click="() => {
                            this.form.job = {
                              name: '',
                              unit: '',
                              id: '01',
                              work_type: 'custom'
                            }
              this.isCreateCustom = true
              }">
                  + Добавить произвольную работу
              </span>
          </div>
          <div class="jobs-li link" v-if="role === 'admin'">
            <span @click="isCreateJob = true">
              + Создать {{ tr[type || $route.params.type] }} в плане
            </span>
          </div>
        </div>
      </div>
      <div class="add-jobs" v-else>
        <div class="select-value" v-if="isCreateCustom" style="width: 100%">
          <el-row>
            <el-col :span="18">
              <el-form-item>
                <el-input style="margin-right: 8px" v-model="form.job.name" placeholder="Найменование работы">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item>
                <el-input style="margin-left: 8px" v-model="form.job.unit" placeholder="Ед. изм."/>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div class="select-value"
             v-if="!$store.state.project.daily_plan || (type || $route.params.type) === 'MATERIALS'">
          <span v-if="form.job.name && !isCreateCustom">{{ tra[type || $route.params.type] }}: <strong>{{
              form.job.name
            }}</strong>
            {{ form.job.is_unit_value ? ', ' + form.job.unit : '' }}
          </span>
          <div v-if="(type || $route.params.type) !== 'TECH' && (type || $route.params.type) !== 'PROF'">

            <el-input :placeholder="isCreateCustom ? 'Факт' : 'Значение'"
                      @input="valueMaterials"
                      :value="form.value" class="input-with-select">
              <template
                v-if="!isCreateCustom"
                slot="append">{{ form.job.is_unit_value ? 'шт' : form.job.unit }}
              </template>
            </el-input>

            <el-input v-if="(type || $route.params.type) === 'MATERIALS' && form.job.is_unit_value" placeholder="Объем"
                      type="number"
                      v-model="total" class="input-with-select">
              <template slot="append">Объем</template>
            </el-input>
            <el-input
              style="margin-top: 10px; width: calc(100%)"
              placeholder="Комментарий"
              type="textarea"
              v-model="form.comment"
            >
            </el-input>
            <div style="margin-top: 10px">
              <span v-if="form.job.is_unit_value">Объем на 1 eд:
                <strong>{{ form.job.unit_value }} {{ form.job.unit }}</strong>
              </span>
            </div>
          </div>
          <div v-else style="display: flex">
            <el-input
              placeholder="Кол-во"
              type="number"
              v-model="form.value" class="input-with-select" style="margin-right: 10px"
            >
            </el-input>
            <el-input
              v-if="available_reports && available_reports[`${type || $route.params.type}_TIME`]"
              placeholder="Часы"
              v-model="form.time"
              type="number"
              class="input-with-select"
            >
            </el-input>
          </div>

          <div style="margin-top: 10px"
               v-if="((type || $route.params.type) === 'JOB') && form.job.plan && !isCreateCustom">
            <span v-if="total_p || total_p === 0">Физ объем: {{ total_p }}</span>
            <span>План: <strong>{{ form.job.plan }}</strong></span>
          </div>
        </div>

        <div class="select-value" v-else>
          <span v-if="form.job && !isCreateCustom">{{ tra[type || $route.params.type] }}: <strong>{{
              form.job.name
            }}</strong>
            {{ form.job.unit &&  `, ${(form.job.unit.label || form.job.unit)}` }}
          </span>
          <div v-if="(type || $route.params.type) !== 'TECH' && (type || $route.params.type) !== 'PROF'">
            <el-row>
              <el-col :span="12">
                <el-input
                  style="margin-right: 8px"
                  placeholder="Сменный план"
                  v-model="form.daily_plan" class="input-with-select">
                </el-input>
              </el-col>
              <el-col :span="12">
                <el-input
                  style="margin-left: 8px"
                  placeholder="Сменный факт"
                  @input="valueMaterials"
                  :value="form.value" class="input-with-select">
                </el-input>
              </el-col>
            </el-row>
            <el-input
              style="margin-top: 10px; margin-right: -10px; width: calc(100% + 8px)"
              placeholder="Комментарий"
              type="textarea"
              v-model="form.comment"
            >
            </el-input>
          </div>
          <div v-else style="display: flex">
            <el-input
              placeholder="Кол-во"
              type="number"
              v-model="form.value" class="input-with-select" style="margin-right: 10px"
            >
            </el-input>
            <el-input
              v-if="available_reports && available_reports[`${type || $route.params.type}_TIME`]"
              placeholder="Часы"
              v-model="form.time"
              type="number"
              class="input-with-select"
            >
            </el-input>
          </div>

          <div style="margin-top: 10px" v-if="((type || $route.params.type) === 'JOB') && form.job.plan">
            <span v-if="total_p || total_p === 0">Физ объем: {{ total_p }}</span>
            <span>План: <strong>{{ form.job.plan }}</strong></span>

          </div>
        </div>
      </div>
      <div v-if="!isCreateJob" slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          v-if="!!form.job"
          @click="save"
        >Сохранить
        </el-button>
        <el-button @click="close">Закрыть</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import firebase from 'firebase';
import JobsCreate from '../../Jobs/Create';
import _ from 'lodash';
import MaterialsCreate from '../../Jobs/Materials';
import {BigNumber} from "bignumber.js";
import {filterJobs} from "../../../../utils/filterJobs";
import {getPermission} from "../../../../firestore/permission";
import UnitSelect from '../../components/unitSelect';

function percentage(num, per) {
  return new BigNumber(num).dividedBy(100)
    .multipliedBy(per).toNumber()
}


export default {
  name: 'AddJobs',
  components: {MaterialsCreate, JobsCreate, UnitSelect},
  props: ['obj', 'index', 'type', 'unit_prop'],
  data() {
    return {
      search: '',
      tr: {
        JOB: 'работу',
        PROF: 'профессию',
        TECH: 'технику',
        MATERIALS: 'материалы',
      },
      tra: {
        JOB: 'работа',
        PROF: 'профессия',
        TECH: 'техника',
        MATERIALS: 'материалы',
      },
      dialogObject: false,
      isCreateJob: false,
      unit: '',
      total_p: null,
      jobs: [],
      step: 0,
      role: 'admin',
      total: 0,
      isCreateCustom: false,
      form: {
        value: '',
        time: '',
        job: null,
        work_type: {},
        daily_plan: '',
        comment: '',
      },
      available_reports: {},
    };
  },

  async mounted() {
    this.permission = await getPermission(this.$store.state.project.id, this.$store.state.company.uid || firebase.auth().currentUser.uid);

    firebase.firestore()
      .collection('projects')
      .doc(this.$store.state.project.id).get().then((sub) => {
      const data = sub.data();
      if (data) {
        const rules = data.rules;
        if (rules) {
          this.role = rules[firebase.auth().currentUser.uid];

          if (data.isDemo) {
            this.role = 'admin';
          }
          this.loading = false;
        }
      }
    });
    this.available_reports = this.$store.state.project.available_reports;

    this.fetchJobs();
  },

  watch: {
    obj() {
      this.fetchJobs();
    },
    dialogObject(d) {
      if (d === true) {
        firebase.firestore()
          .collection('projects')
          .doc(this.$store.state.project.id).get().then((sub) => {
          const data = sub.data();
          if (data) {
            const rules = data.rules;
            if (rules) {
              this.role = rules[firebase.auth().currentUser.uid];

              if (data.isDemo) {
                this.role = 'admin';
              }
              this.loading = false;
            }
          }
        });
        this.available_reports = this.$store.state.project.available_reports;

        this.fetchJobs();
      }
    }
  },

  computed: {
    filteredList() {
      return this.jobs.filter(job => {
        return job.name.toLowerCase().includes(this.search.toLowerCase());
      });
    },
  },
  methods: {
    valueMaterials(n) {

      if (n.match(/^[0-9]+$/) || /%$/.test(n) || /,$/.test(n) || /.$/.test(n) || !String(n).length) {
        this.form.value = String(n).replace(',', '.');

        if ((/%$/.test(n) && (this.type || this.$route.params.type) === 'JOB') && this.form.job.plan) {
          return this.total_p = percentage(Number(this.form.job.plan), Number(this.form.value.replace('%', '')));
        } else {

          this.total = new BigNumber(String(this.form.value).replace(',', '.'))
            .multipliedBy(String(this.form.job.unit_value).replace(',', '.')).toNumber()
        }

        this.total_p = null;
      }
    },
    open() {
      this.dialogObject = true;
      this.step = 0;
      this.total_p = null;
      this.total = 0;

      this.form = {
        value: '',
        time: '',
        job: null,
        work_type: {},
      };
      this.isCreateJob = false;
    },
    fetchJobs() {
      let req = null;
      this.isCreateJob = false;
      if ((this.type || this.$route.params.type) === 'JOB' || (this.type || this.$route.params.type) === 'MATERIALS') {
        req = firebase.firestore()
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('jobs')
          .where('type', '==', (this.type || this.$route.params.type))
          .where(`objects`, 'array-contains-any', [this.obj && this.obj.id || 'all']);
      } else {
        req = firebase.firestore()
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('jobs')
          .where('type', '==', (this.type || this.$route.params.type));
      }

      let result = [];
      req.get()
        .then((data) => {
          data.forEach((subDoc) => {
            const data = subDoc.data();
            result.push({
              id: subDoc.id,
              ...data,
            });
          });
        })
        .finally(() => {
          const result_filter = (result) => {
            if ((this.type || this.$route.params.type) === 'JOB') {
              return filterJobs(result, this.permission, this.obj && this.obj.id || 'all');
            }

            return result
          }

          this.jobs = _.orderBy(result_filter(result), 'index', ['asc']);
        });
    },
    save() {

      if (!this.form.value) {
        this.form.value = 0;
      }

      let total = 0;
      if (this.form.job.unit_value) {
        total = this.total;
      }

      if (this.form.job.unit && this.form.job.unit.label) {
        this.form.job.unit = this.form.job.unit.label;
      }

      this.$emit('add-job', {
        total,
        is_select: (this.unit_prop && this.unit_prop === this.form.job.unit) || null,
        ...this.form,
        is_daily: !!this.$store.state.project.daily_plan,
        value: this.total_p || this.form.value,
      }, this.index);

      this.close();
    },
    close() {
      this.dialogObject = false;
      this.clear();
    },
    clear() {
      this.form = {
        value: '',
        time: '',
        job: null,
        work_type: {},
        daily_plan: '',
        comment: '',
      }
      this.step = 0;
      this.isCreateCustom = false;
    },
  },
};
</script>

<style lang="scss">
.add-jobs {
  display: flex;
  flex-direction: column;

  .jobs-ul {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-top: 8px;
  }

  .jobs-li {
    width: 100%;
    justify-content: flex-start;
    min-height: 36px;
    padding: 8px 10px;
    display: flex;
    text-align: left;
    align-items: center;
    cursor: pointer;
    border-bottom: 1px solid rgba(0, 0, 0, 0.18);

    &:hover {
      background: #eee;
    }

    &:last-child {
      border-bottom: none;
    }
  }

  .select-value {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: flex-start;
    text-align: left;

    .input-with-select {
      margin-top: 12px;
    }

    > > > {
      .el-select .el-input {
        width: 142px;
      }
    }
  }
}

.jobs-create-container {
  margin-top: -46px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Reports/components/AddJobs.vue